// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/popover/style/index.less
// module id = 1781
// module chunks = 0